module.exports = __webpack_public_path__ + "img/Feature_Mockup.550fd3d4.png";